import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from '@/app/App';
import reportWebVitals from './reportWebVitals';

// Render the app directly - using real API at http://127.0.0.1:8000
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode> // Temporarily disabled to avoid double API calls in development
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
